import { type Itinerary } from 'models/Journey';
import { journeyUtils } from 'utils';

// format itinerary option label for Select component
export const formatItineraryOptions = (itineraries: Itinerary[]) => {
  return itineraries.map((itinerary) => {
    const flights = itinerary.flights;

    const firstFlight = flights[0];
    const lastFlightIndex = flights.length - 1;
    const lastFlight = flights[lastFlightIndex];

    const departureAirport = firstFlight.departureAirport;
    const arrivalAirport = lastFlight.arrivalAirport;

    const departureAirportName =
      journeyUtils.cityTranslations(departureAirport);
    const departureAirportIata = departureAirport?.iata;

    const arrivalAirportName = journeyUtils.cityTranslations(arrivalAirport);
    const arrivalAirportIata = arrivalAirport?.iata;

    const itineraryLabel = `${departureAirportName} (${departureAirportIata}) - ${arrivalAirportName} (${arrivalAirportIata})`;

    return {
      label: itineraryLabel,
      value: itinerary.id,
    };
  });
};
